import {
  Dispatch,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react'
import { useLoadScript } from '@react-google-maps/api'

interface GoogleMapsProps {
  children?: React.ReactNode
  apiKey: string
}

interface GoogleMapsContext {
  isLoaded: boolean
  apiKey: string
  place: google.maps.places.PlaceResult | null
  setPlace: Dispatch<SetStateAction<google.maps.places.PlaceResult | null>>
  places: google.maps.places.AutocompletePrediction[]
  setPlaces: Dispatch<
    SetStateAction<google.maps.places.AutocompletePrediction[]>
  >
}

const GoogleMapsContext = createContext<GoogleMapsContext | null>(null)

export const GoogleMapsProvider = ({ children, apiKey }: GoogleMapsProps) => {
  const [places, setPlaces] = useState<
    google.maps.places.AutocompletePrediction[]
  >([])
  const [place, setPlace] = useState<google.maps.places.PlaceResult | null>(
    null,
  )
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: apiKey,
    libraries: ['places'],
  })

  return (
    <GoogleMapsContext.Provider
      value={{ apiKey, place, places, setPlace, setPlaces, isLoaded }}
    >
      <div>{children}</div>
    </GoogleMapsContext.Provider>
  )
}

export const useGoogleMapsContext = () => {
  const context = useContext(GoogleMapsContext)
  if (context === null) {
    throw new Error(
      'useGoogleMapsContext must be used within a GoogleMapsProvider',
    )
  }

  return context
}
